export const PURPOSE_OPTIONS = [
  {
    id: 1,
    label: "Care Management",
    value: "Care Management",
    selected: false,
  },
  {
    id: 1,
    label: "Emergency Care",
    value: "Emergency Care",
    selected: false,
  },
  {
    id: 1,
    label: "Self Requested",
    value: "Self Requested",
    selected: false,
  },
];

export const HEALTH_INFO_TYPE_OPTIONS = [
  {
    id: 1,
    label: "Prescriptions",
    value: "Prescription",
    selected: false,
  },
  {
    id: 2,
    label: "Diagnostic Reports",
    value: "DiagnosticReport",
    selected: false,
  },
  {
    id: 3,
    label: "OP Consultation Records",
    value: "OPConsultation",
    selected: false,
  },
  {
    id: 4,
    label: "Discharge Summary",
    value: "DischargeSummary",
    selected: false,
  },
  {
    id: 5,
    label: "Immunization Records",
    value: "ImmunizationRecord",
    selected: false,
  },
  {
    id: 6,
    label: "Health Document Records",
    value: "HealthDocumentRecord",
    selected: false,
  },
  {
    id: 7,
    label: "Wellness Records",
    value: "WellnessRecord",
    selected: false,
  },
];

export const REQUEST_STATUS_OPTIONS = [
  {
    id: 1,
    name: "Request Initiated",
    value: "Request Initiated",
    selected: false,
  },
  {
    id: 1,
    name: "Request Sent",
    value: "Request Sent",
    selected: false,
  },
  {
    id: 1,
    name: "Request Denied",
    value: "Request Denied",
    selected: false,
  },
  {
    id: 1,
    name: "Consent Granted",
    value: "Consent Granted",
    selected: false,
  },
  {
    id: 1,
    name: "Consent Revoked",
    value: "Consent Revoked",
    selected: false,
  },
  {
    id: 1,
    name: "Consent Expired",
    value: "Consent Expired",
    selected: false,
  },
];

export const CREATED_AT_OPTIONS = [
  {
    id: 1,
    name: "Latest to Oldest",
    value: "latest_to_oldest",
    selected: false,
  },
  {
    id: 1,
    name: "Oldest to Latest",
    value: "oldest_to_latest",
    selected: false,
  },
];

export const GRANTED_AT_OPTIONS = [
  {
    id: 1,
    name: "Latest to Oldest",
    value: "latest_to_oldest",
    selected: false,
  },
  {
    id: 1,
    name: "Oldest to Latest",
    value: "oldest_to_latest",
    selected: false,
  },
];
